<div class="modal-body width-600">
	<span class="modal-header">
		{{getRessource('ModalHeader')}}
	</span>
	<div class="content layout-auto-1">
		<div style="padding: .5rem 0">
			<p style="margin:  .125em 0">
				{{getRessource('ModalDescription')}}
			</p>
			<p style="margin: .125em 0"
			   *ngIf="showCanNotOpenHint">
				{{getRessource('ModalCanNotOpenHint')}}
			</p>
		</div>
		<div class="content"
				 style="padding: .25rem 0">
			<div *ngFor="let task of data.ReceiptDuplicates"
			     class="list-row app-cursor-pointer grid-1-auto"
			     (dblclick)="onClickOpenTaskCheckview(task)"
			     style="padding: 0 0.75rem; line-height: 1.6">
				<div class="grid-auto-1-auto">
	        <span>
		        {{ task.vorgNr }}
	        </span>
					<span style="padding: 0 .5rem">
						<ng-container *ngIf="task.canOpen === 1">
							{{ task.auAuftraggeberShort }}
						</ng-container>
	        </span>
					<span class="typo-right">
						<ng-container *ngIf="task.canOpen === 1">
			        {{ task.aueSchadenNr }}
						</ng-container>
	        </span>
				</div>
				<div class="">
					<i class="search-filter-action fal fa-chevron-right"
					   style="margin: .25rem"
					   [class.disabled]="task.canOpen === 0"
					   (click)="onClickOpenTaskCheckview(task)">
					</i>
				</div>
			</div>
		</div>
	</div>
	<div class="spawn-modal-actions">
		<button (click)="actionDelete()"
		        [class.disabled]="!data.canDelete"
		        class="md-btn">
			{{getRessource('ActionDelete')}}
		</button>
		<button (click)="cancel()" class="md-btn">
			{{getRessource('ActionCancel')}}
		</button>
	</div>
</div>
